// Shared form primitive: an uppercase micro-label above its children.
// Used ~90× across the SPA; extracted so extracted components can import it
// too (app.jsx imports it back, so its own call sites resolve unchanged).
export function Field({ label, children }) {
  return (
    <div>
      <div style={{ fontSize: 10, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.6, color: '#9e9e9e', marginBottom: 3 }}>
        {label}
      </div>
      {children}
    </div>
  );
}
